import React from 'react';
import { EAgreementType } from '../../InvestmentAgreementApp';
import tick from '@images/tick.svg?url';

import * as style from './AgreementRowStyle.module.scss'

type Props = {
  label: string;
  licenceId: string;
  type: EAgreementType;
  isBlocked: boolean;
  isSigned: boolean;
  handleShowAgreementClick: any;
};

export const AgreementRow = ({
  label,
  licenceId,
  type,
  isBlocked,
  isSigned,
  handleShowAgreementClick
}: Props) => {


  const agreementActions = (licenceId: string) => {
    if (isBlocked) return <p>Sign agreement above first.</p>;
    if (isSigned) return <img src={tick} className={style.tick} />;

    return (
      <button
        className={style.signAgreement}
        onClick={handleShowAgreementClick}
      >
        Click to sign
      </button>
    );
  }

  return (
    <div className={style.broker} key={licenceId}>
      <div className={style.brokerSection}>
        <span className={style.brokerName}>{label}</span>
        {agreementActions(licenceId)}
      </div>
    </div>
  );
};
